import React, { ComponentProps } from "react";

export default function XCircleIcon(props: ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="60"
      height="60"
      viewBox="0 0 60 60"
      fill="none"
      {...props}
    >
      <rect width="60" height="60" rx="30" fill="#FAFAFA" />
      <circle cx="30.001" cy="30" r="20" fill="#D82C0D" />
      <path
        d="M37.6339 38.2568L22.3603 22.9832"
        stroke="white"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.3601 38.2565L37.6337 22.9828"
        stroke="white"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
